import withSharedStyles from "./theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  app: {
    width: "100%",
    maxWidth: "100%"
  },
  upLift: {
    marginBottom: theme.spacing(8)
  },
  main: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column"
  },
  scrollBtn: {
    backgroundColor: `${theme.tokens.color.bg} !important`,
    color: theme.tokens.color.ink,
    boxShadow: `${theme.tokens.shadow.float} !important`,
    borderRadius: theme.tokens.radius.pill,
    transition: "all .3s",
    position: "fixed",
    right: 30,
    zIndex: 9,
    border: "none",
    "& svg": {
      fontSize: theme.tokens.iconSize.xl
    },
    [theme.media.belowDesktop]: {
      right: 20
    }
  }
}));

export default withCustomStyles;
